import { useRequest } from 'ahooks';
import * as api from '../../../axios/api';
import util from '../../../utils/utils';

const useGetRecommendSearch = () => {
    const cacheKey = `recommendSearch:${util.getCurrentClientId()}:${util.getUserId() || 'guest'}`;
    const { loading, data, error, run } = useRequest(
        async (params) => {
            const clientId = util.getCurrentClientId();
            const requestParams = { ...params };
            
            if (clientId === 'client-a') {
                // ✅ a环境：总是传递用户ID（确保有用户信息）
                util.ensureUserInfo();
                requestParams.user_id = util.getUserId();
            } else {
                // ✅ b环境：只有登录时才传递用户ID
                if (util.isUserLoggedIn()) {
                    requestParams.user_id = util.getUserId();
                }
            }
            
            requestParams.num = 5;

            // 只有a环境需要添加user_province参数
            if (clientId === 'client-a') {
                requestParams.user_province = ["国家能源局"];
            }

           return api.getRecommendSearch(requestParams);
        },
        {
            refreshDeps: [],
            debounceWait: 0, // ✅ 增加防抖时间，减少频繁请求
            manual: false,
            refreshOnWindowFocus: false,
            refetchOnReconnect: false,
            // ✅ 添加重试配置
            retryCount: 2,
            retryInterval: 1000,
            // ✅ 缓存配置：10分钟内复用
            cacheKey,
            staleTime: 10 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
        }
    );
    
    return {
        recommendSearchLoading: loading,
        recommendSearchData: data?.data?.policy_item_list || [],
        recommendSearchStatisticsData: data?.data?.info_statistics,
        recommendSearchError: error,
        recommendSearchRefresh: run
    };
};

export default useGetRecommendSearch;